module.exports = __webpack_public_path__ + "img/wallet-money.405dd506.svg";